import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import Alert from "./Alert.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'EmptyState',
  props: {
    alertClass: {},
    isInsdeElement: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["empty-state", { 'inside-element': _ctx.isInsdeElement }])
  }, [
    _createVNode(Alert, {
      "with-icon": "",
      show: "",
      variant: "info",
      class: _normalizeClass(_ctx.alertClass || '')
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.$t("emptyState.default")), 1)
        ])
      ]),
      _: 3
    }, 8, ["class"])
  ], 2))
}
}

})